import { IComponentOptions, IController } from 'angular';
import './gmc-avatar.component.scss';

class GmcAvatarController implements IController {
  photo: string;
  active = true;
  indicator = false;

  constructor() {
  }

  public $onInit() {
  }
}

export const GmcAvatarComponent: IComponentOptions = {
  controller: GmcAvatarController,
  template: require('./gmc-avatar.component.html'),
  bindings: {
    photo: '@',
    active: '<?',
    indicator: '<?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-avatar/gmc-avatar.component.ts